import ThumbnailContainer from './ThumbnailContainer';

export default ThumbnailContainer;
